import * as React from 'react';

function SvgTwitter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" width="1em" {...props}>
      <path
        d="M19.5 40C8.73 40 0 31.05 0 20S8.73 0 19.5 0 39 8.95 39 20s-8.73 20-19.5 20zM30 14.02c-.77.34-1.6.58-2.47.68a4.33 4.33 0 001.9-2.38c-.84.49-1.76.85-2.74 1.04a4.3 4.3 0 00-7.34 3.93 12.24 12.24 0 01-8.89-4.5 4.29 4.29 0 001.34 5.75A4.3 4.3 0 019.84 18v.06a4.31 4.31 0 003.46 4.22 4.32 4.32 0 01-1.95.08 4.31 4.31 0 004.03 3A8.65 8.65 0 019 27.13a12.2 12.2 0 006.6 1.93c7.93 0 12.27-6.57 12.27-12.26l-.01-.56A8.75 8.75 0 0030 14.02z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgTwitter;
